import React from 'react';
import { SyntheticEvent } from 'react';
import { Dropdown, DropdownItemProps } from 'semantic-ui-react';

import '../ws/worldspinner.css';
import './Culture.css';

interface Props {
    onChangeCulture: (cultureValue: string) => void;
}
interface State {
    cultureValue: string;
    cultureText: string;
    cultureDesc: string;
}

export class Culture extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        const culture = cultureOptions.find((option: DropdownItemProps) => option.value === "1");
        if (!culture) { throw new Error("Culture.constructor: can't find #1"); }
        this.state = {
            cultureValue: culture.value as string,
            cultureText: culture.text as string,
            cultureDesc: culture.desc as string,
        };
    }

    public render() {
        return <div id="names-culture-segment">
            <div id="wsCulture-outer">
                <div id="wsCulture-mainSection">
                    <h2>
                        Culture: <Dropdown options={cultureOptions} defaultValue={"1"}
                            onChange={(event: SyntheticEvent, data: object) => this.onChangeCulture((data as any).value)} />
                    </h2>
                    <p>
                        {this.state.cultureDesc}
                    </p>
                    <p id="tap-instructions-mobile">
                        <i>Click on any name to copy it to the clipboard.</i>
                    </p>
                    <p id="tap-instructions-desktop">
                        <i>Click on any name to copy it to the clipboard.</i>
                    </p>
                </div>
                <a href="./portraits.html">
                    <div id="wsCulture-portraitSection">
                        <div>
                            <img src={`https://content.worldspinner.com/names/portraits/${this.state.cultureText}.webp`} width={200} alt="portrait" />
                        </div>
                        <div>
                            Make your own portraits with <u>PortraitWorks</u>.
                        </div>
                    </div>
                </a>
            </div >
            {/* <p id="tap-instructions-mobile">
                <i>Tap on any name to copy it to the clipboard.</i>
            </p> */}
        </div >;
    }

    private onChangeCulture(cultureValue: string) {
        const culture = cultureOptions.find((option: DropdownItemProps) => option.value === cultureValue);
        if (!culture) { throw new Error("onChangeCulture: can't find " + cultureValue); }
        this.setState({ cultureValue, cultureText: culture.text as string, cultureDesc: culture.desc as string });
        this.props.onChangeCulture(cultureValue);
    }
}

const cultureOptions: DropdownItemProps[] = [
    { key: '1', value: '1', text: 'Fantasy', desc: "These fantasy names draw from many historical cultures, with a dash of non-historical elements as well. For more a more unified set of names, choose a specific culture above." },
    { key: '1119', value: '1119', text: 'African', desc: "These names are inspired by the Malinke people of Africa. " },
    { key: '1105', value: '1105', text: 'Celtic', desc: "These names are inspired by the historical Celts whose many different tribes inhabited Europe, starting around the 10th century BCE. Their names were often derived from Gaelic." },
    { key: '1112', value: '1112', text: 'Chinese', desc: "These names are inspired by the Chinese, both ancient and modern." },
    { key: '2002', value: '2002', text: 'Dwarven', desc: "The Dwarves are a hardy people who treasure strength, crafts, and... well... treasure." },
    { key: '1110', value: '1110', text: 'Egyptian', desc: "These names are inspired by the peoples of ancient Egypt." },
    { key: '2001', value: '2001', text: 'Elven', desc: "The Elves are a diverse people, known for their love of nature and the arts, as well as their skill in magic." },
    { key: '1100', value: '1100', text: 'English', desc: "The English people and language, including their names, are the result of successive waves of different cultures taking control." },
    { key: '1108', value: '1108', text: 'Germanic', desc: "These names are inspired by historical Germanic tribes such as the Goths." },
    { key: '2004', value: '2004', text: 'Gnomish', desc: "The Gnomes are a quirky, often whimsical people, and their names reflect this. Just try to read a list of Gnomish names aloud without cracking a smile!" },
    { key: '1106', value: '1106', text: 'Greek', desc: "These names are inspired by people of Greek, both ancient and modern." },
    { key: '2009', value: '2009', text: 'Halfling', desc: "The Halflings are typically country folk who live close to the land and prize comfort, kinship, and a good meal." },
    { key: '1104', value: '1104', text: 'Mongol', desc: "These names are inspired by the people of Mongolia, both historical and modern." },
    { key: '2005', value: '2005', text: 'Orcish', desc: "Orcs are known for being direct and blunt. Their names are typically short and gutteral, well suited to being shouted on the battlefield." },
    { key: '1103', value: '1103', text: 'Persian', desc: "These names are inspired by the people of Persia, in what is now Iran." },
    { key: '1101', value: '1101', text: 'Roman', desc: "These names are inspired by the people of ancient Rome. As with much of Roman society, there were well established rules determining how citizens were named." },
    { key: '1102', value: '1102', text: 'Viking', desc: "The Vikings were aggressive seafaring traders, famers, and warriors. Girls were often given a last name based on their mother, and boys based on their father." },
];
